<template>
  <div class="lms-grading-student-list-home">
    <h4 v-t="'home.facilitatorGrading.filter.student'" />

    <div class="lms-grading-student-list-home__loading"
         v-if="loadingState === 1">
      <JwlIcon loading-icon margin-right/>
      {{ $t('general.loadingData') }}
    </div>

    <JwlError
      v-else-if="loadingState === -1"
      :jwl-error="error" />

    <div
      v-else
      class="lms-grading-student-list-home__student-list">
      <FacilitatorGradingStudentListItem
          v-for="(clcData, clcId) in clcsAndGradableStudents"
          class="lms-grading-student-list-home__row"
          :class="getClcClasses(clcData.clc)"
          :key="clcId"
          :classroom-id="classroomId"
          :course-code="courseCode"
          :clcs-and-gradable-students="clcsAndGradableStudents"
          :clc-data="clcData"
          :clc-id="clcId"
          :selected-classroom="selectedClassroom"
      />
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    showTasks: Boolean,
    showCount: Boolean,
    classroomId: Number,
    courseCode: String,
    selectedClassroom: Object,
  });

  const learningStore = useLearningStore();

  const limit = 1;
  const offset = 0;

  const loadingState = ref(0);
  const error = ref(null);
  const gradableClcCount = ref(0);
  const clcsAndGradableStudents = ref(null);

  const selectListItem = (jwlId) => {
    return {
      name: 'facilitator_grading_students',
      params: {
        classroomId: props.classroomId.toString(),
        course: props.selectedClassroom.course.courseCode,
        studentJwlId: jwlId,
      },
      query: {
        filterByStudent: jwlId,
      },
    };
  };

  const notPublished = (student) => {
    if (student.submittedPublishedCount) {
      return student.submittedPublishedCount;
    }
    return 0;
  };

  const notGraded = (student) => {
    if (student.submittedNotGradedCount) {
      return student.submittedNotGradedCount;
    }
    return 0;
  };

  const getClcsAndStudents = () => {
    loadingState.value = 1;
    const url = `facilitator/classroom/${props.classroomId}/course/${props.courseCode}/clcs/students/${offset}/${limit}`;
    learningStore.getData(url)
      .then((data) => {
        gradableClcCount.value = data.count;
        clcsAndGradableStudents.value = data.clcsAndGradableStudents;
        loadingState.value = 2;
      })
      .catch((e) => {
        error.value = e;
        loadingState.value = -1;
      });
  };

  const clcNotPublished = (clc) => {
    if (clc?.countGradeNotPublished) {
      return clc.countGradeNotPublished;
    }
    return 0;
  };

  const clcNotGraded = (clc) => {
    if (clc?.countNotGraded) {
      return clc.countNotGraded;
    }
    return 0;
  };

  const getClcClasses = (item) => {
    return `countNotGraded-${clcNotGraded(item)} countGradeNotPublished-${clcNotPublished(item)}`;
  };

  onMounted(() => {
    getClcsAndStudents();
  });
</script>

<style lang="scss">
.lms-grading-student-list-home {
  display: block !important;
  &__student-list {
    display: grid;
    // grid-gap: 1rem;
    // grid-template-columns: 1fr 1fr;
    list-style: none;
    padding: 0 0;

    ul {
      list-style: none;
      padding-left: 1rem;
    }
  }

  &__course-toggle {
    --toggle-color: var(--color-white);

    align-items: center;
    display: flex;
    grid-area: toggle;
    height: 100%;
    justify-content: center;
  }

  &__link {
    color: var(--color-black);
    list-style: none;
    text-decoration: none;
  }

  &__clc {
    font-weight: bold;
  }
  &__row {
    margin-bottom: 1rem;
  }
}
</style>
